__turbopack_context__.v({
  "figure": "image-module-scss-module__Cc8UIW__figure",
  "imageWrapper": "image-module-scss-module__Cc8UIW__imageWrapper",
  "imgCaption": "image-module-scss-module__Cc8UIW__imgCaption",
});
